<template>
  <div class="page-container">
    <PageHeader title="题目分类" show-breadcrumb />

    <SearchPanel>
      <el-input v-model.trim="query.qtcName" placeholder="分类名称" clearable size="small" @keyup.enter.native="handleSearch" />
      <template #actions>
        <el-button type="primary" icon="el-icon-search" size="small" @click="handleSearch">查询</el-button>
        <el-button icon="el-icon-refresh" size="small" @click="handleReset">重置</el-button>
        <el-button type="success" icon="el-icon-plus" size="small" @click="handleAdd">新增分类</el-button>
      </template>
    </SearchPanel>

    <TablePanel title="题目分类列表">
      <el-table :data="list" v-loading="loading" size="small" stripe :height="tableHeight">
        <el-table-column type="index" label="序号" width="80" align="center" />
        <el-table-column prop="qtcName" label="分类名称" min-width="240" align="center" show-overflow-tooltip />
        <el-table-column prop="qtcPkWeight" label="PK抽题权重" min-width="140" align="center">
          <template slot-scope="{ row }">
            <el-tag size="small" type="warning">{{ row.qtcPkWeight != null ? row.qtcPkWeight : 0 }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" size="mini" style="color:#409eff" @click="handleEdit(row)">编辑</el-button>
            <el-button type="text" size="mini" style="color:#e6a23c" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page.currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page.pageSize"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
      />
    </TablePanel>

    <!-- 新增/编辑分类弹框 -->
    <el-dialog :title="dialogType === 'add' ? '新增分类' : '编辑分类'" :visible.sync="dialogVisible" width="480px" v-dialog-drag-resize>
      <el-form ref="formRef" :model="form" :rules="rules" label-width="110px" size="small">
        <el-form-item label="分类名称" prop="qtcName">
          <el-input v-model.trim="form.qtcName" placeholder="请输入分类名称" />
        </el-form-item>
        <el-form-item label="PK抽题权重" prop="qtcPkWeight">
          <el-input-number v-model="form.qtcPkWeight" :min="0" :max="100" controls-position="right" style="width:100%" />
          <div style="color:#909399; font-size:12px; line-height:1.6;">PK 对战抽题时各分类的权重，所有分类权重之和需 ≤ 100。</div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="submitLoading" @click="submitDialog">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader.vue'
import SearchPanel from '@/components/SearchPanel.vue'
import TablePanel from '@/components/TablePanel.vue'
import { getZqpkQuestionTopicClassList, addZqpkQuestionTopicClass, updateZqpkQuestionTopicClass, deleteZqpkQuestionTopicClass } from '@/api/api'

export default {
  name: 'QuestionTopicClass',
  components: { PageHeader, SearchPanel, TablePanel },
  data () {
    return {
      loading: false,
      tableHeight: 400,
      list: [],
      query: { qtcName: '' },
      page: { currentPage: 1, pageSize: 10, total: 0 },
      dialogVisible: false,
      dialogType: 'add',
      submitLoading: false,
      form: { qtcId: null, qtcName: '', qtcPkWeight: 0 },
      rules: {
        qtcName: [{ required: true, message: '请输入分类名称', trigger: 'blur' }]
      }
    }
  },
  created () { this.fetchList() },
  mounted () {
    this.$nextTick(this.calcTableHeight)
    window.addEventListener('resize', this.calcTableHeight)
  },
  beforeDestroy () { window.removeEventListener('resize', this.calcTableHeight) },
  methods: {
    calcTableHeight () {
      const el = this.$el.querySelector('.el-table')
      if (!el) return
      this.tableHeight = window.innerHeight - el.getBoundingClientRect().top - 80
    },
    async fetchList () {
      this.loading = true
      try {
        const params = { ...this.query, currentPage: this.page.currentPage, pageSize: this.page.pageSize }
        const res = await getZqpkQuestionTopicClassList(params)
        this.list = res.data || []
        this.page.total = res.total || 0
      } catch (e) { this.list = []; this.page.total = 0 } finally { this.loading = false }
    },
    handleSearch () { this.page.currentPage = 1; this.fetchList() },
    handleReset () { this.query = { qtcName: '' }; this.handleSearch() },
    handleSizeChange (size) { this.page.pageSize = size; this.handleSearch() },
    handlePageChange (page) { this.page.currentPage = page; this.fetchList() },
    handleAdd () {
      this.dialogType = 'add'
      this.form = { qtcId: null, qtcName: '', qtcPkWeight: 0 }
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
    },
    handleEdit (row) {
      this.dialogType = 'edit'
      this.form = { qtcId: row.qtcId, qtcName: row.qtcName || '', qtcPkWeight: row.qtcPkWeight != null ? Number(row.qtcPkWeight) : 0 }
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
    },
    submitDialog () {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        this.submitLoading = true
        try {
          if (this.dialogType === 'add') {
            await addZqpkQuestionTopicClass(this.form)
            this.$message.success('新增成功')
          } else {
            await updateZqpkQuestionTopicClass(this.form)
            this.$message.success('编辑成功')
          }
          this.dialogVisible = false
          this.fetchList()
        } catch (e) {} finally {
          this.submitLoading = false
        }
      })
    },
    async handleDelete (row) {
      try { await this.$confirm('确定删除该题目分类？', '提示', { type: 'warning' }) } catch { return }
      try {
        await deleteZqpkQuestionTopicClass({ qtcId: row.qtcId })
        this.$message.success('删除成功')
        this.fetchList()
      } catch (e) {}
    }
  }
}
</script>
